import { SubmissionError } from 'redux-form';
import { createFormAction } from 'redux-form-saga';
import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { authentication, login, logout, getCourseLessons } from 'service/api';
import { hideModal, showModal } from './modal';
import { getGeneralDataAction } from './general';
import { I18n } from 'react-redux-i18n';

// Constants - action names
export const USER_AUTH = 'pv-kultu/user/USER_AUTH';
export const USER_AUTH_SUCCESS = 'pv-kultu/user/USER_AUTH_SUCCESS';
export const USER_AUTH_FAILED = 'pv-kultu/user/USER_AUTH_FAILED';
export const USER_LOGOUT = 'pv-kultu/user/USER_LOGOUT';
export const USER_LOGOUT_SUCCESS = 'pv-kultu/user/USER_LOGOUT_SUCCESS';
export const USER_LOGOUT_FAILED = 'pv-kultu/user/USER_LOGOUT_FAILED';
export const USER_SELECT_COURSE = 'pv-kultu/user/SELECT_COURSE'
export const COURSE_DATA_SUCCESS = 'pv-kultu/user/COURSE_DATA_SUCCESS'
export const COURSE_DATA_FAILED = 'pv-kultu/user/COURSE_DATA_FAILED'

// Helpers
//--

export function isUnauthorized(error) {
  return error.status === 401 || error.message === "Unauthorized";
}

// Initial state
const initialState = {
  user: undefined,
  currentCourse: undefined,
  loading: false,
  error: undefined,
  courseData: undefined
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case USER_AUTH:
      return Object.assign({}, state, {loading: true});
    case USER_AUTH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        user: action.user
      });
    case USER_AUTH_FAILED:
      return Object.assign({}, state, {
        loading: false,
        error: action.error
      });
    case USER_LOGOUT:
      return Object.assign({}, state, {loading: true});
    case USER_LOGOUT_SUCCESS:
      return Object.assign({}, state, initialState);
    case USER_LOGOUT_FAILED:
      return Object.assign({}, initialState, {error: action.error});
    case USER_SELECT_COURSE:
      return Object.assign({}, state, { currentCourse: action.course, courseData: undefined, loading: true });
    case COURSE_DATA_SUCCESS:
      const examClasses = action.courseData.examClasses.map(item => item.name);
      const currentCourse = Object.assign({}, state.currentCourse, { examClasses });
      //TODO remove is* version when backend fixed
      const proCourse = !!action.courseData.isProCourse || !!action.courseData.proCourse;
      const personTransportCourse = !!action.courseData.isPersonTransportCourse || !!action.courseData.personTransportCourse;
      return Object.assign({}, state, { currentCourse: currentCourse, courseData: { lessons: action.courseData.lessons, examClasses, proCourse, personTransportCourse}, error: undefined, loading: false });
    case COURSE_DATA_FAILED:
      return Object.assign({}, state, { courseData: { error: action.error }, loading: false });
    default:
      return state;
  }
}

// Actions
export function getUser() {
  return {type: USER_AUTH};
}

export function getUserSuccess(data) {
  return {type: USER_AUTH_SUCCESS, user: data};
}

export function getUserFailed(error) {
  return {type: USER_AUTH_FAILED, error};
}

export function logoutUser() {
  return {type: USER_LOGOUT};
}

export function logoutUserSuccess(data) {
  return {type: USER_LOGOUT_SUCCESS, user: data};
}

export function logoutUserFailed(error) {
  return {type: USER_LOGOUT_FAILED, error};
}

export function selectCourse(course) {
  return { type: USER_SELECT_COURSE, course: course }
}

export function getCourseDataSuccess(data) {
  return { type: COURSE_DATA_SUCCESS, courseData: data }
}

export function getCourseDataFailed(error) {
  return { type: COURSE_DATA_FAILED, error }
}



// Login is handled by redux-form-saga - login actions are dispatched like loginAction.success()
export const loginAction = createFormAction('LOGIN');

// Sagas
export function* handleAuthSaga() {
  try {
    const data = yield call(authentication);
    yield put(getUserSuccess(data));
    yield put(getGeneralDataAction());
  } catch (error) {
    yield put(getUserFailed(error));
    yield put(showModal('LOGIN'));
  }
}

export function* handleCourseChangeSaga(action) {
  try {
    const data = yield call(getCourseLessons, action.course)
    yield put(getCourseDataSuccess(data))
  } catch (error) {
    yield put(getCourseDataFailed(error))
  }

}

export function* handleLoginSaga(action) {
  try {
    // Api requires this as text
    const options = {
      contentType: 'text/plain'
    };
    yield call(login, action.payload, options);
    yield put(loginAction.success());
    yield put(getUser());
    yield put(hideModal());
  } catch (error) {
    console.error(error);
    const formError = new SubmissionError({
      // username: 'User with this login is not found', // specific field error
      _error: I18n.t('app.login_failed'), // global form error
    });
    yield put(loginAction.failure(formError));
  }
}

export function* handleLogoutSaga() {
  try {
    yield call(logout);
    yield put(logoutUserSuccess());
    yield put(showModal('LOGIN'));
  } catch (error) {
    console.error(error);
    yield put(logoutUserFailed(error));
    if (error.message === "Unauthorized") {
      yield put(showModal('LOGIN'));
    }
  }
}

function* watchAuth() {
  yield takeEvery(USER_AUTH, handleAuthSaga);
  yield takeEvery(loginAction.REQUEST, handleLoginSaga);
  yield takeEvery(USER_LOGOUT, handleLogoutSaga);
  yield takeLatest(USER_SELECT_COURSE, handleCourseChangeSaga);
}

export function* userSagas() {
  yield all([
    watchAuth(),
    // + other user sagas here e.g. watchUpdate() if needed to update some user related stuff
  ]);
}



// WEBPACK FOOTER //
// ./src/ducks/user.js